export default __webpack_public_path__ + "static/media/filterReset.a6ace89b.svg";